var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill-rule":"nonzero","fill":"#85847C"}},[_c('path',{attrs:{"d":"M.5 4.851h16v2H.5zM.5.851h16v2H.5zM.5 8.851h16v2H.5zM.5 12.851h12v2H.5z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }